var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-unit-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitBulkProcessData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("prepayments.rate_of_pre_payment"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "base-input" },
                  [
                    _c(
                      "money",
                      _vm._b(
                        {
                          staticClass: "input-field",
                          class: {
                            invalid: _vm.$v.formData.rate_prepayment.$error,
                          },
                          model: {
                            value: _vm.formData.rate_prepayment,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "rate_prepayment", $$v)
                            },
                            expression: "formData.rate_prepayment",
                          },
                        },
                        "money",
                        _vm.percentageFormatMoneyComponent,
                        false
                      )
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$v.formData.rate_prepayment.$error
                  ? _c("div", [
                      !_vm.$v.formData.rate_prepayment.between
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("validation.enter_valid_tax_rate")
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 base-input" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("general.financing_ratio"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c(
                  "money",
                  _vm._b(
                    {
                      staticClass: "input-field",
                      class: {
                        invalid: _vm.$v.formData.financing_ratio.$error,
                      },
                      model: {
                        value: _vm.formData.financing_ratio,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "financing_ratio", $$v)
                        },
                        expression: "formData.financing_ratio",
                      },
                    },
                    "money",
                    _vm.percentageFormatMoneyComponent,
                    false
                  )
                ),
                _vm._v(" "),
                _c("base-input", {
                  attrs: {
                    type: "hidden",
                    name: "invoice_ids",
                    "tab-index": "1",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.invoice_ids.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.invoice_ids,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "invoice_ids", $$v)
                    },
                    expression: "formData.invoice_ids",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.financing_ratio.$error
                  ? _c("div", [
                      !_vm.$v.formData.financing_ratio.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.financing_ratio.between
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("validation.enter_valid_tax_rate")
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c(
              "base-button",
              {
                staticClass: "mr-3",
                attrs: { outline: true, color: "theme", type: "button" },
                on: { click: _vm.closeBulkProcessModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: {
                  loading: _vm.isLoading,
                  color: "theme",
                  icon: "save",
                  type: "submit",
                },
              },
              [_vm._v("\n        Process\n      ")]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }